/**
 * Interior height for the Actions menu popover. Popover uses fixed `height` for skills-on,
 * search, and group drill-in so row counts do not resize the panel; skills-off home (group list only) uses
 * {@link WORKSPACE_AGENT_ACTIONS_MENU_POPOVER_MAX_HEIGHT_PX} as `max-height` only.
 */
export const WORKSPACE_AGENT_ACTIONS_MENU_MAX_HEIGHT_PX = 274;

/** `Popover.Content` `border` (1px) — with `border-box`, add so the interior matches {@link WORKSPACE_AGENT_ACTIONS_MENU_MAX_HEIGHT_PX}. */
export const WORKSPACE_AGENT_ACTIONS_MENU_POPOVER_BORDER_INSET_PX = 2;

export const WORKSPACE_AGENT_ACTIONS_MENU_POPOVER_MAX_HEIGHT_PX =
  WORKSPACE_AGENT_ACTIONS_MENU_MAX_HEIGHT_PX + WORKSPACE_AGENT_ACTIONS_MENU_POPOVER_BORDER_INSET_PX;

/** Composer trigger keys on Actions menu footer rows (Strato `shortcutChip`). */
export const WORKSPACE_AGENT_ACTIONS_MENU_ADD_REFERENCE_KEYBOARD_HINT = '@';
export const WORKSPACE_AGENT_ACTIONS_MENU_SAVED_SKILLS_KEYBOARD_HINT = '/';

export const WORKSPACE_AGENT_ACTIONS_MENU_SEARCH_PLACEHOLDER = 'Search an action';
export const WORKSPACE_AGENT_ACTIONS_MENU_SEARCH_PLACEHOLDER_WITH_SKILLS = 'Search an action or skill';

export const WORKSPACE_AGENT_ACTIONS_MENU_SAVED_SKILLS_LABEL = 'Saved skills';

export const WORKSPACE_AGENT_ACTIONS_MENU_EMPTY_SEARCH_MESSAGE = 'No matching actions or skills';
export const WORKSPACE_AGENT_ACTIONS_MENU_EMPTY_TASKS_MESSAGE = 'No matching tasks';
